// Constants
export {
  CIRCLE_BATCHING_NAME,
  CIRCLE_BATCHING_VERSION,
  CIRCLE_BATCHING_SCHEME,
  GATEWAY_AUTH_VALIDITY_WINDOW_SECONDS,
} from './constants';

// Detection
export { supportsBatching, isBatchPayment, getVerifyingContract } from './detection';

// Types
export type {
  BatchExtra,
  BatchFacilitatorConfig,
  TransferWithAuthorizationMessage,
  BatchEvmSigner,
  BatchPayload,
} from './types';

// Lifecycle hook types (mirror @x402/core hooks).
// See https://docs.x402.org/advanced-concepts/lifecycle-hooks
export type {
  // shared contexts
  HookPaymentPayload,
  HookPaymentRequirements,
  HookPaymentRequired,
  HookVerifyResponse,
  HookSettleResponse,
  VerifyContext,
  VerifyResultContext,
  VerifyFailureContext,
  SettleContext,
  SettleResultContext,
  SettleFailureContext,
  VerifiedPaymentCanceledContext,
  VerifiedPaymentCancellationReason,
  // resource-server hooks
  BeforeVerifyHook,
  AfterVerifyHook,
  OnVerifyFailureHook,
  BeforeSettleHook,
  AfterSettleHook,
  OnSettleFailureHook,
  OnVerifiedPaymentCanceledHook,
  // facilitator hooks
  FacilitatorBeforeVerifyHook,
  FacilitatorAfterVerifyHook,
  FacilitatorOnVerifyFailureHook,
  FacilitatorBeforeSettleHook,
  FacilitatorAfterSettleHook,
  FacilitatorOnSettleFailureHook,
  // HTTP server hook
  ProtectedRequestHook,
  ProtectedRequestContext,
  ProtectedRouteConfig,
  // client hooks
  PaymentCreationContext,
  PaymentCreatedContext,
  PaymentCreationFailureContext,
  PaymentResponseContext,
  BeforePaymentCreationHook,
  AfterPaymentCreationHook,
  OnPaymentCreationFailureHook,
  OnPaymentResponseHook,
} from './hooks';
